import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import customParseFormat from 'dayjs/plugin/customParseFormat'
// import { checker } from '@/utils/updateChecker'
import { showVconsole } from '@/env'
import '@/scripts'
// import '@/utils/webpush'
import '@/hooks/useTrack'
import '@/hooks/usePWA'
import '@/app'
import '@/assets/main.scss'
import 'virtual:svg-icons-register'

import initVconsole from '@/utils/initVconsole'
if (showVconsole) initVconsole()
dayjs.extend(utc)
dayjs.extend(timezone) // 使用时区插件
dayjs.extend(weekOfYear)
dayjs.extend(customParseFormat)

// Service Worker 注册已移至 webpush 统一管理
// 避免重复注册冲突

